module.exports = __webpack_public_path__ + "img/hasdone.a241ff1e.jpg";